/**
 * Manual locale strings (no i18n library). Keys are flat dot-notation.
 */
export const messages = {
  th: {
    'brand.university': 'มหาวิทยาลัยแม่ฟ้าหลวง',
    'brand.maintenanceShort': 'ระบบซ่อมบำรุง',

    'common.other': 'อื่นๆ',
    'common.logout': 'ออกจากระบบ',
    'common.langTh': 'ไทย',
    'common.langEn': 'EN',

    'login.title': 'ระบบแจ้งซ่อมออนไลน์',
    'login.subtitle': 'มหาวิทยาลัยแม่ฟ้าหลวง',
    'login.signIn': 'ลงชื่อเข้าใช้งานระบบ',
    'login.mfuHint': '* โปรดใช้ MFU mail ในการ login',
    'login.userManual': 'คู่มือการใช้งาน',
    'login.swalGoogleLoadingTitle': 'กำลังโหลดระบบ',
    'login.swalGoogleLoadingText': 'ระบบกำลังเชื่อมต่อกับ Google กรุณารอสักครู่และพยายามใหม่อีกครั้ง',
    'login.ok': 'ตกลง',
    'login.verifyingTitle': 'กำลังตรวจสอบข้อมูล...',
    'login.verifyingText': 'กรุณารอสักครู่ ระบบกำลังนำท่านเข้าสู่ระบบ',
    'login.successTitle': 'เข้าสู่ระบบสำเร็จ',
    'login.errorTitle': 'เกิดข้อผิดพลาด',
    'login.failGeneric': 'เข้าสู่ระบบล้มเหลว',

    'nav.userManual': 'คู่มือการใช้งาน',
    'nav.logout': 'ออกจากระบบ',
    'nav.dashboard': 'แดชบอร์ด',
    'nav.repairs': 'งานซ่อม',
    'nav.staff': 'จัดการข้อมูล เจ้าหน้าที่',
    'nav.jobTypes': 'จัดการข้อมูล ประเภทงาน',
    'nav.buildings': 'จัดการข้อมูล อาคาร',

    'mainuser.pageTitle': 'แจ้งซ่อม',
    'mainuser.reportBtn': 'แจ้งซ่อม',
    'mainuser.tabReports': 'รายการแจ้งซ่อม',
    'mainuser.tabHistory': 'ประวัติแจ้งซ่อม',
    'mainuser.ticketCancelledTitle': 'ใบแจ้งซ่อมถูกยกเลิก',
    'mainuser.ticketCancelledText': 'ใบแจ้งซ่อมนี้ถูกยกเลิกแล้ว',
    'mainuser.evalBeforeNewTitle': 'แจ้งเตือนจากระบบ',
    'mainuser.evalBeforeNewText': 'กรุณาทำการประเมินการซ่อมที่เสร็จสิ้นแล้วก่อน จึงจะสามารถแจ้งซ่อมใหม่ได้',
    'mainuser.thanksEvalTitle': 'ขอบคุณสำหรับการประเมิน 🎉',
    'mainuser.evalTicketNo': 'เลขที่ใบงาน:',
    'mainuser.evalScore': 'คะแนน:',
    'mainuser.evalStars': 'ดาว ⭐',
    'mainuser.evalComment': 'ความคิดเห็น:',
    'mainuser.evalNoComment': 'ไม่มี',

    'dashboard.kpiTotalRequests': 'จำนวนการแจ้งซ่อมทั้งหมด',
    'dashboard.kpiInProgress': 'กำลังดำเนินการ',
    'dashboard.kpiCompleted': 'ปิดงานแล้ว',
    'dashboard.kpiOverSla': 'เกิน SLA',
    'dashboard.kpiSatisfaction': 'คะแนนความพึงพอใจเฉลี่ย',
    'dashboard.kpiAwaitingEval': 'รอประเมิน',
    'dashboard.pieByDepartment': 'สัดส่วนงานแจ้งซ่อมตามหน่วยงาน',
    'dashboard.pieByCategory': 'สัดส่วนงานแจ้งซ่อมตามหมวดหมู่',
    'dashboard.barMonthly': 'สถิติการแจ้งซ่อมรายเดือน',
    'dashboard.heatmap': 'แผนที่ความร้อน',
    'dashboard.ticketDetails': 'รายละเอียด Ticket',
    'dashboard.reportPdf': 'รายงาน',
    'dashboard.noData': 'ไม่มีข้อมูล',
    'dashboard.slaTarget': 'เป้า:',
    'dashboard.rangeCustom': 'กำหนดเอง',
    'dashboard.rangeToday': 'วันนี้',
    'dashboard.rangeWeek': 'สัปดาห์นี้',
    'dashboard.rangeMonth': 'เดือนนี้',
    'dashboard.rangeYear': 'ปีนี้',
    'dashboard.rangeAll': 'ทั้งหมด',
    'dashboard.periodPrefix': 'ช่วงเวลา: ',
    'dashboard.pdfTitle': 'รายงานสรุปผลการแจ้งซ่อม',
    'dashboard.pdfPrintedAt': 'พิมพ์เมื่อ:',
    'dashboard.pdfKpiTotal': 'จำนวนงานทั้งหมด',
    'dashboard.pdfKpiCompleted': 'ปิดงานแล้ว',
    'dashboard.pdfKpiInProgress': 'กำลังดำเนินการ',
    'dashboard.pdfKpiOverdue': 'เกินกำหนด (SLA)',
    'dashboard.pdfKpiAwaiting': 'รอประเมิน',
    'dashboard.pdfKpiSatisfaction': 'ความพึงพอใจเฉลี่ย',
    'dashboard.pdfWorkListTitle': 'รายละเอียดของงานที่มีมา',
    'dashboard.colTicketNo': 'เลขที่ใบแจ้งซ่อม',
    'dashboard.colDateReported': 'วันที่แจ้ง',
    'dashboard.colReporterDept': 'ผู้แจ้ง/หน่วยงาน',
    'dashboard.colStatus': 'สถานะ',
    'dashboard.colSla': 'SLA',
    'dashboard.colClosedAt': 'เวลาปิดงาน',
    'dashboard.noRowsInPeriod': 'ไม่มีข้อมูลในช่วงเวลานี้',
    'dashboard.summaryTitle': 'สรุปข้อมูลรายหมวดหมู่ (Summary)',
    'dashboard.summaryColDept': 'หน่วยงาน / แผนก',
    'dashboard.summaryColCategory': 'หมวดหมู่ / หน่วยงาน',
    'dashboard.summaryColTotal': 'จำนวนงานทั้งหมด',
    'dashboard.summaryColCompleted': 'ปิดงานแล้ว',
    'dashboard.summaryColInProgress': 'กำลังดำเนินการ',
    'dashboard.summaryColOverdue': 'เกินกำหนด',
    'dashboard.noSummaryRows': 'ไม่มีข้อมูลสรุป',
    'dashboard.pdfModalTitle': 'เลือกช่วงเวลาสำหรับดาวน์โหลด PDF',
    'dashboard.dateFrom': 'ตั้งแต่วันที่',
    'dashboard.dateTo': 'ถึงวันที่',
    'dashboard.download': 'ดาวน์โหลด',
    'dashboard.slaOverdue': 'เกินกำหนด',
    'dashboard.slaOnTime': 'ทันเวลา',
    'dashboard.supervisorPrefix': 'หัวหน้างาน: ',
    'dashboard.status.pending': 'รอดำเนินการ',
    'dashboard.status.assigned': 'มอบหมายแล้ว',
    'dashboard.status.in_progress': 'กำลังดำเนินการ',
    'dashboard.status.done': 'เสร็จสิ้น',
    'dashboard.status.welldone': 'เสร็จสิ้น (ประเมินแล้ว)',
    'dashboard.status.cancelled': 'ยกเลิก',
    'dashboard.status.rejected': 'ปฏิเสธ',
    'dashboard.field.ticketNo': 'เลขที่ใบแจ้งซ่อม',
    'dashboard.field.dateInformed': 'วันที่แจ้ง',
    'dashboard.field.reporter': 'ผู้แจ้ง / หน่วยงาน',
    'dashboard.field.category': 'ประเภทงาน',
    'dashboard.field.status': 'สถานะ',
    'dashboard.field.sla': 'SLA',
    'dashboard.field.assignee': 'ผู้รับผิดชอบ',
    'dashboard.field.closedDate': 'วันที่ปิดงาน',
    'dashboard.pdfPeriodTpl': 'ข้อมูลตั้งแต่วันที่ {from} ถึง {to}',
    'dashboard.shortMonth1': 'ม.ค.',
    'dashboard.shortMonth2': 'ก.พ.',
    'dashboard.shortMonth3': 'มี.ค.',
    'dashboard.shortMonth4': 'เม.ย.',
    'dashboard.shortMonth5': 'พ.ค.',
    'dashboard.shortMonth6': 'มิ.ย.',
    'dashboard.shortMonth7': 'ก.ค.',
    'dashboard.shortMonth8': 'ส.ค.',
    'dashboard.shortMonth9': 'ก.ย.',
    'dashboard.shortMonth10': 'ต.ค.',
    'dashboard.shortMonth11': 'พ.ย.',
    'dashboard.shortMonth12': 'ธ.ค.',

    'ticketDetail.title': 'รายละเอียดใบแจ้งซ่อม',
    'ticketDetail.timeline.waitShort': 'รอ',
    'ticketDetail.timeline.submitted': 'ส่งเรื่อง',
    'ticketDetail.timeline.received': 'รับเรื่อง',
    'ticketDetail.timeline.inRepair': 'กำลังซ่อม',
    'ticketDetail.timeline.awaitingEval': 'รอประเมิน',
    'ticketDetail.timeline.done': 'เสร็จสิ้น',
    'ticketDetail.role.user': 'User',
    'ticketDetail.role.supervisor': 'Supervisor',
    'ticketDetail.role.technician': 'Technician',
    'ticketDetail.role.userConfirm': 'User Confirm',
    'ticketDetail.rating.n1': 'ปรับปรุง',
    'ticketDetail.rating.n2': 'พอใช้',
    'ticketDetail.rating.n3': 'ปานกลาง',
    'ticketDetail.rating.n4': 'ดี',
    'ticketDetail.rating.n5': 'ดีมาก',
    'ticketDetail.evalPlease': '⭐ กรุณาให้คะแนนความพึงพอใจ',
    'ticketDetail.evalResult': '⭐ ผลการประเมินความพึงพอใจ',
    'ticketDetail.evalSubmit': 'ยืนยันการประเมิน',
    'ticketDetail.saving': 'กำลังบันทึก...',
    'ticketDetail.cancelWhy': 'สาเหตุการยกเลิกงาน',
    'ticketDetail.noReason': 'ไม่ระบุเหตุผล',
    'ticketDetail.assignees': '👤 ผู้รับผิดชอบงาน',
    'ticketDetail.supervisorAssigner': 'หัวหน้าผู้มอบหมาย:',
    'ticketDetail.when': 'เมื่อ:',
    'ticketDetail.technician': 'ช่างผู้ปฏิบัติงาน:',
    'ticketDetail.waitTechAccept': '(รอช่างกดรับงาน)',
    'ticketDetail.finishedWhen': 'ซ่อมเสร็จเมื่อ:',
    'ticketDetail.sectionReport': '🛠️ ข้อมูลการแจ้งซ่อม',
    'ticketDetail.ticketNo': 'เลขที่ใบแจ้งซ่อม (Ticket No.)',
    'ticketDetail.reporter': 'ชื่อผู้แจ้ง:',
    'ticketDetail.onBehalf': 'แจ้งแทน:',
    'ticketDetail.phoneMobile': 'เบอร์โทรศัพท์ส่วนตัว:',
    'ticketDetail.phoneWork': 'เบอร์โทรศัพท์ที่ทำงาน:',
    'ticketDetail.jobType': 'ประเภทงานซ่อม:',
    'ticketDetail.workArea': 'พื้นที่ปฏิบัติงาน:',
    'ticketDetail.timeSlot': 'ช่วงเวลาที่สะดวก:',
    'ticketDetail.mapPoint': '📍 แผนที่จุดแจ้งซ่อม:',
    'ticketDetail.openMaps': 'เปิดใน Google Maps',
    'ticketDetail.problem': 'ปัญหา/งานซ่อม:',
    'ticketDetail.photoBefore': 'รูปภาพประกอบ (ก่อนซ่อม):',
    'ticketDetail.workOutcome': '📝 สรุปผลการดำเนินงาน',
    'ticketDetail.fixDetail': 'รายละเอียดการแก้ไข:',
    'ticketDetail.photoAfter': 'รูปจากช่าง (หลังซ่อม):',
    'ticketDetail.close': 'ปิด',
    'ticketDetail.outdoor': 'นอกอาคาร',
    'ticketDetail.locationBuilding': 'ตึก {b} / ห้อง {r}',
    'ticketDetail.mapPinTitle': 'จุดแจ้งซ่อม',
    'ticketDetail.swalEvalOk': 'บันทึกการประเมินเรียบร้อย',
    'ticketDetail.swalError': 'เกิดข้อผิดพลาด',
    'ticketDetail.swalSaveFail': 'ไม่สามารถบันทึกได้',
    'ticketDetail.techUnknown': 'ไม่ระบุชื่อ (ID Only)',
    'ticketDetail.techPending': '- (รอดำเนินการ)',
    'ticketDetail.cancelTicketBtn': 'ยกเลิกงานซ่อม',
    'ticketDetail.deptCombined': 'แผนก/หน่วยงาน:',
    'ticketDetail.phonePersonalShort': 'เบอร์โทรส่วนตัว:',
    'ticketDetail.phoneWorkShort': 'เบอร์โทรที่ทำงาน:',
    'ticketDetail.otherCatBanner': 'งานประเภท "อื่นๆ" - ต้องมอบหมายหน่วยงาน',
    'ticketDetail.userSpecifiedJob': 'ประเภทงานที่ผู้ใช้ระบุ:',
    'ticketDetail.pickDept': 'เลือกหน่วยงานที่เหมาะสม:',
    'ticketDetail.placeholderDept': '-- กรุณาเลือกหน่วยงาน --',
    'ticketDetail.assigningDept': 'กำลังมอบหมาย...',
    'ticketDetail.assignDeptBtn': 'มอบหมายหน่วยงาน',
    'ticketDetail.assignTechHeading': '⚡ มอบหมายงานให้ช่าง',
    'ticketDetail.changeTechHeading': '⚡ เปลี่ยนช่างผู้ปฏิบัติงาน',
    'ticketDetail.pickTech': 'เลือกช่างผู้ปฏิบัติงาน:',
    'ticketDetail.placeholderTech': '-- กรุณาเลือกช่าง --',
    'ticketDetail.confirmAssignTech': 'ยืนยันการมอบหมาย',
    'ticketDetail.confirmChangeTechBtn': 'ยืนยันการเปลี่ยนช่าง',
    'ticketDetail.waitUserEval': '🕒 รอ User ประเมิน',
    'ticketDetail.adminAssignBox': '📋 ข้อมูลการมอบหมายโดย Admin',
    'ticketDetail.originalUserType': 'ประเภทงานเดิมที่ User ระบุ:',
    'ticketDetail.adminAssignedDeptLabel': 'หน่วยงานที่ Admin มอบหมาย:',
    'ticketDetail.adminAssignerLabel': 'Admin ผู้มอบหมาย:',
    'ticketDetail.assignDateLabel': 'วันที่มอบหมาย:',
    'ticketDetail.supervisorLabelRole': 'หัวหน้าผู้มอบหมาย (Supervisor):',
    'ticketDetail.technicianLabelRole': 'ช่างผู้ปฏิบัติงาน (Technician):',
    'ticketDetail.changeTechShort': 'เปลี่ยนช่าง',
    'ticketDetail.otherAssignedSuffix': ' (มอบหมายแล้ว)',
    'ticketDetail.otherWaitSuffix': ' (รอมอบหมาย)',
    'ticketDetail.noLocationDetail': 'ไม่ระบุรายละเอียด',
    'ticketDetail.timeSuffix': ' น.',
    'ticketDetail.youMarker': '(คุณ)',
    'ticketDetail.noName': 'ไม่ระบุชื่อ',
    'ticketDetail.techNotYet': '- (ยังไม่ระบุ)',
    'ticketDetail.confirmAssignDeptTitle': 'ยืนยันการมอบหมายหน่วยงาน?',
    'ticketDetail.confirmAssignDeptHtml': 'คุณต้องการมอบหมายงานนี้ให้<br><strong>{name}</strong><br>ใช่หรือไม่?',
    'ticketDetail.assignDeptSuccess': 'มอบหมายหน่วยงานเรียบร้อยแล้ว ระบบได้ส่ง Email แจ้งเตือนไปยัง Supervisor ของหน่วยงานแล้ว',
    'ticketDetail.assignDeptFail': 'ไม่สามารถมอบหมายหน่วยงานได้',
    'ticketDetail.fetchCategoriesFail': 'ไม่สามารถดึงข้อมูลหน่วยงานได้',
    'ticketDetail.connectFail': 'ไม่สามารถเชื่อมต่อกับเซิร์ฟเวอร์ได้',
    'ticketDetail.confirmChangeTechTitle': 'ยืนยันการเปลี่ยนช่าง?',
    'ticketDetail.confirmAssignTitle': 'ยืนยันการมอบหมาย?',
    'ticketDetail.confirmChangeTechHtml': 'คุณต้องการเปลี่ยนช่างผู้ปฏิบัติงานให้เป็น<br><strong>{name}</strong><br>ใช่หรือไม่?',
    'ticketDetail.confirmAssignTechHtml': 'คุณต้องการมอบหมายงานนี้ให้<br><strong>{name}</strong><br>ใช่หรือไม่?',
    'ticketDetail.selectedTechFallback': 'ช่างที่เลือก',
    'ticketDetail.assignTechOk': 'มอบหมายงานเรียบร้อยแล้ว ระบบได้ส่ง Email แจ้งเตือนไปยังช่างแล้ว',
    'ticketDetail.changeTechOk': 'เปลี่ยนช่างเรียบร้อยแล้ว',
    'ticketDetail.assignTechFail': 'ไม่สามารถมอบหมายงานได้',
    'ticketDetail.cancelTicketTitle': 'ยืนยันการยกเลิกงานซ่อม?',
    'ticketDetail.cancelTicketHtml': 'คุณแน่ใจหรือไม่ที่จะยกเลิกงานซ่อมนี้? การยกเลิกไม่สามารถย้อนกลับได้<br><br><b style="color:red;">*กรุณาระบุเหตุผลการยกเลิกงาน</b>',
    'ticketDetail.cancelPlaceholder': 'กรอกเหตุผล...',
    'ticketDetail.cancelAria': 'เหตุผลการยกเลิก',
    'ticketDetail.cancelConfirmBtn': 'ยืนยันยกเลิก',
    'ticketDetail.closeBtn': 'ปิด',
    'ticketDetail.cancelReasonRequired': 'กรุณาระบุเหตุผลการยกเลิกงาน!',
    'ticketDetail.cancelOk': 'ยกเลิกงานซ่อมเรียบร้อยแล้ว',
    'ticketDetail.cancelFail': 'ไม่สามารถยกเลิกงานซ่อมได้',
    'ticketDetail.supervisor.forwardOther': 'ส่งงานให้หน่วยงานอื่น',
    'ticketDetail.supervisor.forwardOtherShort': '🔄 ส่งงานให้หน่วยงานอื่น',
    'ticketDetail.supervisor.pickTargetDept': 'เลือกหน่วยงานปลายทาง:',
    'ticketDetail.supervisor.placeholderDept': '-- กรุณาเลือกหน่วยงาน --',
    'ticketDetail.supervisor.yourDeptTag': '(หน่วยงานของคุณ)',
    'ticketDetail.supervisor.processing': 'กำลังดำเนินการ...',
    'ticketDetail.supervisor.confirmForward': 'ยืนยันการส่งต่อ',
    'ticketDetail.supervisor.forwardConfirmTitle': 'ยืนยันการส่งต่อ?',
    'ticketDetail.supervisor.forwardConfirmText': 'คุณต้องการส่งต่องานนี้ให้หน่วยงานอื่นใช่หรือไม่?',
    'ticketDetail.supervisor.forwardOk': 'ส่งต่องานซ่อมให้หน่วยงานอื่นเรียบร้อยแล้ว',
    'ticketDetail.supervisor.forwardFail': 'ไม่สามารถส่งต่องานได้',
    'ticketDetail.supervisor.waitEvalLine': '🕒 รอ User ประเมิน',
    'ticketDetail.tech.pageTitle': 'รายละเอียดงานซ่อม',
    'ticketDetail.tech.newJobTitle': '🛠️ งานใหม่ได้รับมอบหมาย',
    'ticketDetail.tech.newJobHint': 'ตรวจสอบรายละเอียดด้านล่าง แล้วกดรับงานเพื่อเริ่มดำเนินการ',
    'ticketDetail.tech.acceptJob': 'รับงานนี้',
    'ticketDetail.tech.closeSection': '🏁 รายงานผลการซ่อม (ปิดงาน)',
    'ticketDetail.tech.repairDetailLabel': 'รายละเอียดการซ่อม/แก้ไข:',
    'ticketDetail.tech.repairPlaceholder': 'อธิบายสิ่งที่ได้ดำเนินการซ่อมแซม...',
    'ticketDetail.tech.photoAfterRequired': 'รูปภาพหลังซ่อมเสร็จ (จำเป็น):',
    'ticketDetail.tech.choosePhoto': 'เลือกรูปภาพ...',
    'ticketDetail.tech.confirmClose': 'ยืนยันการปิดงาน',
    'ticketDetail.tech.uploading': 'กำลังอัปโหลด...',
    'ticketDetail.tech.selfReporterBadge': 'แจ้งซ่อมโดยคุณ',
    'ticketDetail.tech.statusLine': 'สถานะ:',
    'ticketDetail.tech.waitReporterEval': '✅ งานนี้ดำเนินการเสร็จสิ้นแล้ว รอผู้แจ้งประเมิน',
    'ticketDetail.tech.jobWelldone': '🏆 งานนี้เสร็จสิ้นสมบูรณ์แล้ว',
    'ticketDetail.tech.supervisorWhen': 'เมื่อ:',
    'ticketDetail.tech.youTechnician': 'ช่างผู้ปฏิบัติงาน (คุณ):',
    'ticketDetail.tech.locationDetailLabel': 'รายละเอียดสถานที่:',
    'ticketDetail.tech.problemLabel': 'รายละเอียดปัญหา:',
    'ticketDetail.tech.photoAfterOptional': 'รูปภาพประกอบ (ก่อนซ่อม):',
    'ticketDetail.tech.acceptConfirmTitle': 'ยืนยันรับงาน',
    'ticketDetail.tech.acceptConfirmText': 'คุณต้องการรับงานนี้ใช่หรือไม่?',
    'ticketDetail.tech.acceptConfirmBtn': 'รับงาน',
    'ticketDetail.tech.acceptOkTitle': 'รับงานเรียบร้อย',
    'ticketDetail.tech.acceptOkText': 'สามารถเริ่มดำเนินการได้เลย',
    'ticketDetail.tech.acceptFail': 'ไม่สามารถรับงานได้',
    'ticketDetail.tech.rejectJob': 'ปฏิเสธงาน (ส่งคืนหัวหน้างาน)',
    'ticketDetail.tech.rejectConfirmTitle': 'ปฏิเสธงานซ่อมนี้?',
    'ticketDetail.tech.rejectConfirmText': 'งานนี้จะถูกส่งกลับไปยังหัวหน้างาน (Supervisor) เพื่อมอบหมายใหม่',
    'ticketDetail.tech.rejectReasonPlaceholder': 'กรุณาระบุเหตุผลการปฏิเสธงาน (เช่น ไม่ใช่งานในหน้าที่, ไม่มีอุปกรณ์เฉพาะทาง)...',
    'ticketDetail.tech.rejectReasonRequired': 'กรุณาระบุเหตุผลในการปฏิเสธงาน',
    'ticketDetail.tech.rejectConfirmBtn': 'ยืนยันปฏิเสธงาน',
    'ticketDetail.tech.rejectOkTitle': 'ปฏิเสธงานเรียบร้อย',
    'ticketDetail.tech.rejectOkText': 'ส่งงานกลับไปยังหัวหน้างานแล้ว',
    'ticketDetail.tech.rejectFail': 'ไม่สามารถปฏิเสธงานได้',
    'ticketDetail.tech.rejectedAlertTitle': 'งานนี้เคยถูกปฏิเสธโดยช่าง',
    'ticketDetail.tech.rejectedByLabel': 'ช่างผู้ปฏิเสธ:',
    'ticketDetail.tech.rejectedReasonLabel': 'เหตุผล:',
    'ticketDetail.tech.rejectedBadge': '⚠️ ช่างปฏิเสธ',
    'ticketDetail.tech.fileTooBig': 'ขนาดไฟล์ใหญ่เกินไป กรุณาเลือกไฟล์ใหม่',
    'ticketDetail.tech.needPhotoTitle': 'กรุณาอัปโหลดรูปภาพ',
    'ticketDetail.tech.needPhotoText': 'ต้องอัปโหลดรูปหลังซ่อมเสร็จก่อนปิดงาน',
    'ticketDetail.tech.needDetailTitle': 'กรุณากรอกรายละเอียด',
    'ticketDetail.tech.needDetailText': 'ต้องระบุรายละเอียดการซ่อมแซมก่อนปิดงาน',
    'ticketDetail.tech.closeConfirmTitle': 'ยืนยันปิดงาน',
    'ticketDetail.tech.closeConfirmText': 'คุณต้องการปิดงานซ่อมนี้ใช่หรือไม่?',
    'ticketDetail.tech.closeOkTitle': 'บันทึกสำเร็จ',
    'ticketDetail.tech.closeOkText': 'ส่งงานซ่อมเรียบร้อยแล้ว',
    'ticketDetail.tech.closeFail': 'ไม่สามารถส่งงานได้',
    'ticketDetail.statusFull.pending': 'ส่งเรื่องแล้ว (รอทีมงาน)',
    'ticketDetail.statusFull.assigned': 'รับเรื่องแล้ว (รอช่างรับงาน)',
    'ticketDetail.statusFull.in_progress': 'กำลังดำเนินการ',
    'ticketDetail.statusFull.done': 'ซ่อมเสร็จ',
    'ticketDetail.statusFull.welldone': 'ปิดงานสมบูรณ์',

    'table.user.col.ticketNo': 'เลขที่ใบแจ้งซ่อม',
    'table.user.col.reportedAt': 'วัน/เวลา แจ้ง',
    'table.user.col.detail': 'รายละเอียด',
    'table.user.col.status': 'สถานะ',
    'table.user.onBehalf': 'แจ้งแทน:',
    'table.user.btn.track': 'ติดตาม',
    'table.user.btn.cancelRequest': 'ยกเลิกแจ้งซ่อม',
    'table.user.legend1': 'ส่งเรื่องแล้ว',
    'table.user.legend2': 'รับเรื่องแล้ว',
    'table.user.legend3': 'กำลังดำเนินการ',
    'table.user.legend4': 'เสร็จสิ้น',
    'table.user.status.pending': 'ส่งเรื่องแล้ว',
    'table.user.status.assigned': 'รับเรื่องแล้ว',
    'table.user.status.in_progress': 'กำลังดำเนินการ',
    'table.user.status.done': 'เสร็จสิ้น',
    'table.user.status.welldone': 'เสร็จสิ้น',
    'table.user.status.cancelled': 'ยกเลิกแล้ว',
    'table.user.unknownDept': 'ไม่ระบุ',
    'table.user.swalCancelTitle': 'ยืนยันการยกเลิก?',
    'table.user.swalCancelHtml': 'คุณต้องการยกเลิกการแจ้งซ่อมนี้ใช่หรือไม่?<br><br><b style="color:red;">*กรุณาระบุเหตุผลการยกเลิกงาน</b>',
    'table.user.swalPlaceholder': 'กรอกเหตุผล...',
    'table.user.swalReasonRequired': 'กรุณาระบุเหตุผลการยกเลิกงาน!',
    'table.user.swalSuccess': 'ยกเลิกสำเร็จ!',
    'table.user.swalSuccessText': 'รายการแจ้งซ่อมถูกยกเลิกเรียบร้อยแล้ว',
    'table.user.swalErrCancel': 'เกิดข้อผิดพลาดในการยกเลิก',
    'table.user.swalErrNetwork': 'เชื่อมต่อเซิร์ฟเวอร์ไม่ได้',
    'table.user.btnConfirmCancel': 'ยืนยันการยกเลิก',
    'table.user.btnBack': 'ย้อนกลับ',
    'table.user.timeSuffix': ' น.',
    'table.common.itemsPerPage': 'แสดงต่อหน้า:',

    'table.admin.col.ticketNo': 'เลขที่ใบแจ้งซ่อม',
    'table.admin.col.reportedAt': 'วัน/เวลา แจ้ง',
    'table.admin.col.detail': 'รายละเอียด',
    'table.admin.col.status': 'สถานะ',
    'table.admin.onBehalf': 'แจ้งแทน:',
    'table.admin.btn.detail': 'ดูรายละเอียด',
    'table.admin.btn.assignDept': 'มอบหมายหน่วยงาน',
    'table.admin.legend1': 'รอรับเรื่อง',
    'table.admin.legend2': 'รับเรื่องแล้ว',
    'table.admin.legend3': 'กำลังดำเนินการ',
    'table.admin.legend4': 'เสร็จสิ้น',
    'table.admin.legend5': 'ยกเลิกแจ้งซ่อม',
    'table.admin.col.reporterDetail': 'ผู้แจ้ง / รายละเอียด',
    'table.admin.col.actions': 'จัดการ',
    'table.admin.status.pending': 'รอรับเรื่อง',
    'table.admin.status.assigned': 'รับเรื่องแล้ว',
    'table.admin.status.in_progress': 'กำลังดำเนินการ',
    'table.admin.status.done': 'เสร็จสิ้น',
    'table.admin.status.welldone': 'ปิดงานสมบูรณ์',
    'table.admin.status.cancelled': 'ยกเลิกแล้ว',
    'table.admin.subAssigned': ' (มอบหมายแล้ว)',
    'table.admin.subWaitAssign': ' (รอมอบหมาย)',
    'table.admin.noUserName': 'ไม่ระบุชื่อ',

    'table.tech.col.date': 'วันที่',
    'table.tech.col.issueDetail': 'รายละเอียดงาน / ผู้แจ้ง',
    'table.tech.reportedDateLabel': 'วันที่แจ้งซ่อม',
    'table.tech.byPrefix': 'โดย:',
    'table.tech.supervisorFallback': 'หัวหน้า',
    'table.tech.reportedBy': 'แจ้งโดย:',
    'table.tech.badgeReporter': 'แจ้งซ่อม',
    'table.tech.badgeAssignee': 'งานรับ',
    'table.tech.legend1': 'ส่งเรื่องแล้ว',
    'table.tech.legend2': 'รับเรื่องแล้ว',
    'table.tech.legend3': 'กำลังดำเนินการ',
    'table.tech.legend4': 'เสร็จสิ้น',
    'table.tech.status.pending': 'ส่งเรื่องแล้ว (รอทีมงาน)',
    'table.tech.status.assigned': 'งานเข้าใหม่',
    'table.tech.status.in_progress': 'กำลังดำเนินการ',
    'table.tech.status.done': 'ดำเนินการเสร็จสิ้น',
    'table.tech.status.welldone': 'ปิดงานสมบูรณ์',
    'table.tech.status.cancelled': 'ยกเลิกแล้ว',
    'table.tech.action.acceptJob': 'รับงาน',
    'table.tech.action.finishJob': 'เสร็จงาน',
    'table.tech.action.detail': 'ดูรายละเอียด',
    'table.tech.noUserName': 'ไม่ระบุชื่อ',

    'table.supervisor.col.reporterDetail': 'ผู้แจ้ง / รายละเอียด',
    'table.supervisor.badgeReporter': 'แจ้งซ่อม',
    'table.supervisor.badgeDept': 'งานแผนก',
    'table.supervisor.noCategory': 'ไม่ระบุหมวดหมู่',
    'table.supervisor.noUserName': 'ไม่ระบุชื่อ',
    'table.supervisor.action.assign': 'มอบหมายงาน',
    'table.supervisor.action.track': 'ติดตาม',

    'reportList.pageTitle': 'งานซ่อม',
    'reportList.newRequest': 'แจ้งซ่อม',
    'reportList.tabActive': 'รายการแจ้งซ่อม',
    'reportList.tabHistory': 'ประวัติแจ้งซ่อม',

    'sendReport.modalTitle': 'แจ้งซ่อม',
    'sendReport.sectionRepair': 'รายละเอียดการซ่อม',
    'sendReport.sectionRepairHint': 'ระบุปัญหาและสถานที่',
    'sendReport.jobType': 'ประเภทงานซ่อม',
    'sendReport.noJobTypes': 'ไม่พบข้อมูลประเภทงานซ่อม',
    'sendReport.otherTypeLabel': 'ระบุประเภทงานอื่นๆ',
    'sendReport.otherTypePlaceholder': 'ระบุประเภทงานซ่อมที่ต้องการ...',
    'sendReport.problemLabel': 'ปัญหา/งานซ่อม',
    'sendReport.problemPlaceholder': 'อธิบายปัญหาหรืองานซ่อมที่ต้องการ...',
    'sendReport.imageLabel': 'แนบรูปภาพ',
    'sendReport.pickOrCapture': 'เลือกไฟล์/ถ่าย รูปภาพ',
    'sendReport.remove': 'ลบ',
    'sendReport.takePhoto': 'ถ่ายรูป',
    'sendReport.choosePhoto': 'เลือกรูป',
    'sendReport.imageHint': 'รองรับไฟล์รูปภาพ เช่น .jpg, .png',
    'sendReport.workArea': 'พื้นที่ปฏิบัติงาน',
    'sendReport.insideBuilding': 'ในอาคาร',
    'sendReport.insideBuildingSub': 'Building',
    'sendReport.outsideBuilding': 'นอกอาคาร',
    'sendReport.outsideBuildingSub': 'Outdoor',
    'sendReport.buildingRoom': 'อาคาร - ห้อง',
    'sendReport.buildingPlaceholder': 'ระบุ อาคาร-ห้อง (เช่น C3-201 หรือ A1-1-201)',
    'sendReport.buildingFormatHint': '* กรุณาระบุรูปแบบ: อาคาร-ห้อง (เช่น C3-201)',
    'sendReport.buildingFound': 'พบข้อมูลอาคาร:',
    'sendReport.pinLocation': 'ปักหมุดตำแหน่ง',
    'sendReport.reporterSection': 'ข้อมูลผู้แจ้ง',
    'sendReport.reporterHint': 'รายละเอียดผู้ติดต่อ',
    'sendReport.reporterName': 'ชื่อผู้แจ้ง',
    'sendReport.onBehalfLabel': 'แจ้งแทน (ระบุชื่อผู้ต้องการแจ้งซ่อม)',
    'sendReport.onBehalfPlaceholder': 'ระบุชื่อผู้แจ้งแทน (ถ้ามี)',
    'sendReport.personalPhone': 'เบอร์โทรศัพท์ส่วนตัว',
    'sendReport.workPhone': 'เบอร์โทรศัพท์ที่ทำงาน',
    'sendReport.phonePlaceholderMobile': 'เช่น 0900000000',
    'sendReport.phonePlaceholderWork': 'เช่น 021234567',
    'sendReport.availability': 'วันที่และช่วงเวลาที่สะดวก',
    'sendReport.dateLabel': 'วันที่:',
    'sendReport.startLabel': 'เริ่ม:',
    'sendReport.endLabel': 'สิ้นสุด:',
    'sendReport.availabilityHint': 'เลือกวันที่และช่วงเวลาที่สะดวกในการซ่อม',
    'sendReport.cancel': 'ยกเลิก',
    'sendReport.confirm': 'ยืนยัน',
    'sendReport.submitting': 'กำลังส่ง...',
    'sendReport.defaultFirstName': 'ผู้ใช้',
    'sendReport.defaultLastName': 'งาน',
    'sendReport.timeSuffix': ' เวลา ',
    'sendReport.errEndAfterStart': 'เวลาสิ้นสุดต้องมากกว่าเวลาเริ่ม และ ไม่สามารถข้ามวันได้',
    'sendReport.errImageOnly': 'กรุณาเลือกไฟล์รูปภาพเท่านั้น',
    'sendReport.errImageSize': 'ไฟล์ภาพขนาดใหญ่เกินไป',
    'sendReport.errImageProcess': 'เกิดข้อผิดพลาดในการประมวลผลรูปภาพ',
    'sendReport.errPhoneRequired': 'กรุณากรอกเบอร์โทรศัพท์ส่วนตัว',
    'sendReport.errPhoneDigits': 'กรุณากรอกเบอร์โทร 9–10 หลัก (ตัวเลขเท่านั้น)',
    'sendReport.errPickDate': 'กรุณาเลือกวันที่สะดวก',
    'sendReport.errPickTime': 'กรุณาเลือกช่วงเวลาที่สะดวก',
    'sendReport.errPickJobType': 'กรุณาเลือกประเภทงานซ่อม',
    'sendReport.errSpecifyOther': 'กรุณาระบุประเภทงานซ่อม',
    'sendReport.errWorkArea': 'กรุณาเลือกพื้นที่ปฏิบัติงาน',
    'sendReport.errBuildingFormat': 'กรุณาระบุอาคาร-ห้อง ให้ถูกต้องตามรูปแบบ (เช่น C3-201)',
    'sendReport.errMapPin': 'กรุณาปักหมุดตำแหน่งบนแผนที่',
    'sendReport.errProblem': 'กรุณาอธิบายปัญหาหรืองานซ่อม',
    'sendReport.errAttachImage': 'กรุณาแนบรูปภาพ',
    'sendReport.swalIncompleteTitle': 'ข้อมูลไม่ครบถ้วน',
    'sendReport.swalIncompleteText': 'กรุณากรอกข้อมูลให้ครบถ้วนก่อนส่งแจ้งซ่อม',
    'sendReport.otherPrefix': 'อื่นๆ',
    'sendReport.confirmLocation': 'สถานที่:',
    'sendReport.outdoorLocated': 'นอกอาคาร (ระบุพิกัดแล้ว)',
    'sendReport.confirmJobType': 'ประเภทงาน:',
    'sendReport.confirmProblem': 'ปัญหา:',
    'sendReport.confirmOnBehalf': 'แจ้งแทน:',
    'sendReport.confirmPersonalPhone': 'เบอร์ส่วนตัว:',
    'sendReport.confirmWorkPhone': 'เบอร์ที่ทำงาน:',
    'sendReport.confirmAvailability': 'เวลาที่สะดวก:',
    'sendReport.swalConfirmTitle': 'ยืนยันข้อมูลการแจ้งซ่อม',
    'sendReport.swalEdit': 'แก้ไข',
    'sendReport.swalSuccessTitle': 'แจ้งซ่อมเรียบร้อย',
    'sendReport.swalErrorTitle': 'เกิดข้อผิดพลาด',
    'sendReport.swalErrorText': 'ไม่สามารถส่งข้อมูลแจ้งซ่อมได้ กรุณาลองใหม่อีกครั้ง',

    'mgmt.cancel': 'ยกเลิก',
    'mgmt.save': 'บันทึก',
    'mgmt.add': 'เพิ่ม',
    'mgmt.edit': 'แก้ไข',
    'mgmt.delete': 'ลบ',
    'mgmt.actions': 'จัดการ',
    'mgmt.confirm': 'ยืนยัน',
    'mgmt.confirmDelete': 'ยืนยันลบ',
    'mgmt.processing': 'กำลังดำเนินการ...',
    'mgmt.loadingDelete': 'กำลังลบข้อมูล...',
    'mgmt.loadingRead': 'กำลังอ่านไฟล์...',
    'mgmt.loadingSave': 'กำลังบันทึกข้อมูล...',
    'mgmt.loadingDept': 'กำลังโหลดข้อมูลหน่วยงาน...',
    'mgmt.errFillAll': 'กรุณากรอกข้อมูลให้ครบทุกช่อง',
    'mgmt.errFillAllShort': 'กรุณากรอกข้อมูลให้ครบ',
    'mgmt.success': 'สำเร็จ',
    'mgmt.warn': 'แจ้งเตือน',
    'mgmt.error': 'ผิดพลาด',
    'mgmt.editSaved': 'แก้ไขข้อมูลแล้ว',
    'mgmt.saveSaved': 'บันทึกข้อมูลเรียบร้อย',
    'mgmt.addSaved': 'เพิ่มข้อมูลเรียบร้อย',
    'mgmt.deleteUserTitle': 'ต้องการลบผู้ใช้นี้หรือไม่?',
    'mgmt.deleteUserBulkTitle': 'ต้องการลบผู้ใช้ที่เลือกหรือไม่?',
    'mgmt.sureDelete': 'คุณแน่ใจที่จะลบจริงๆใช่ไหม?',
    'mgmt.demoteUserSuffix': 'จะถูกเปลี่ยนเป็น User ทั่วไป',
    'mgmt.demoteUsersBulk': 'ผู้ใช้ที่เลือกทั้งหมดจะถูกเปลี่ยนเป็น User ทั่วไป',
    'mgmt.demoteSuccess': 'ปรับสิทธิ์ผู้ใช้เป็น User เรียบร้อย',
    'mgmt.countItems': 'จำนวน',
    'mgmt.itemsUnit': 'รายการ',
    'mgmt.batchDeleted': 'ลบสำเร็จ',
    'mgmt.batchFailed': 'ล้มเหลว',
    'mgmt.batchAdded': 'เพิ่มสำเร็จ',
    'mgmt.doneTitle': 'เสร็จสิ้น',
    'mgmt.donePartial': 'เสร็จสิ้น (บางรายการมีปัญหา)',
    'mgmt.noData': 'ไม่มีข้อมูล',
    'mgmt.noDataToSave': 'ไม่พบข้อมูลที่จะบันทึก',
    'mgmt.fileReadError': 'ไม่สามารถอ่านไฟล์ได้ หรือรูปแบบไม่ถูกต้อง',
    'mgmt.rowIncompleteSuffix': 'ข้อมูลไม่ครบถ้วน',
    'mgmt.errOperation': 'ไม่สามารถดำเนินการได้',
    'mgmt.deleteBuildingTitle': 'ยืนยันการลบ?',
    'mgmt.deleteBuildingBulkTitle': 'ยืนยันการลบอาคาร?',
    'mgmt.deleteBuildingSure': 'คุณแน่ใจที่จะลบจริงๆใช่ไหม?',
    'mgmt.deleteBuildingText': 'คุณต้องการลบอาคาร',
    'mgmt.deleteBuildingAndRooms': 'และห้องทั้งหมดใช่หรือไม่?',
    'mgmt.buildingWillDelete': 'จะถูกลบถาวร',
    'mgmt.buildingsSelectedWillDelete': 'อาคารที่เลือกทั้งหมด จะถูกลบถาวร',
    'mgmt.deleteBuildingBulkText': 'คุณต้องการลบอาคารที่เลือกจำนวน',
    'mgmt.deleteOk': 'ลบสำเร็จ',
    'mgmt.deleteBuildingDone': 'ลบข้อมูลอาคารเรียบร้อยแล้ว',
    'mgmt.cannotDelete': 'ไม่สามารถลบข้อมูลได้',
    'mgmt.editRoomSaved': 'แก้ไขชื่อห้องเรียบร้อย',
    'mgmt.editFail': 'แก้ไขไม่สำเร็จ',
    'mgmt.addFail': 'เพิ่มข้อมูลไม่สำเร็จ',
    'mgmt.loadFail': 'โหลดข้อมูลไม่สำเร็จ',
    'mgmt.saveFail': 'บันทึกไม่สำเร็จ',
    'mgmt.deleteFail': 'ลบไม่สำเร็จ',

    'staffMgmt.pageTitle': 'จัดการข้อมูล เจ้าหน้าที่',
    'staffMgmt.addStaff': 'เพิ่มเจ้าหน้าที่',
    'staffMgmt.deleteSelected': 'ลบที่เลือก',
    'staffMgmt.addModal': 'เพิ่มเจ้าหน้าที่',
    'staffMgmt.editModal': 'แก้ไขข้อมูลเจ้าหน้าที่',
    'staffMgmt.previewModal': 'ตัวอย่างข้อมูลจากไฟล์',
    'staffMgmt.firstName': 'ชื่อ',
    'staffMgmt.lastName': 'นามสกุล',
    'staffMgmt.email': 'อีเมล',
    'staffMgmt.phone': 'เบอร์โทรศัพท์',
    'staffMgmt.userType': 'ประเภทผู้ใช้',
    'staffMgmt.department': 'หน่วยงาน',
    'staffMgmt.allDepts': 'ทุกหน่วยงาน',
    'staffMgmt.selectDept': 'โปรดเลือกหน่วยงาน',
    'staffMgmt.addViaXlsx': 'เพิ่มด้วยไฟล์ .xlsx',
    'staffMgmt.templateFile': 'ตัวอย่างไฟล์',
    'staffMgmt.confirmBulk': 'ยืนยันการเพิ่มข้อมูล',
    'staffMgmt.deptLabel': 'หน่วยงาน:',
    'staffMgmt.yourDept': 'แผนกของคุณ',

    'jobTypeMgmt.pageTitle': 'จัดการข้อมูล ประเภทงาน',
    'jobTypeMgmt.addDept': 'เพิ่มหน่วยงาน',
    'jobTypeMgmt.deptNameCol': 'ชื่อหน่วยงาน',
    'jobTypeMgmt.jobTypesCol': 'ข้อมูลประเภทงาน',
    'jobTypeMgmt.icon': 'ไอคอน',
    'jobTypeMgmt.jobTypeName': 'ชื่อประเภทงาน',
    'jobTypeMgmt.slaHours': 'SLA (ชั่วโมง)',
    'jobTypeMgmt.slaShort': 'SLA (ชม.)',
    'jobTypeMgmt.status': 'สถานะ',
    'jobTypeMgmt.active': 'เปิดใช้งาน',
    'jobTypeMgmt.inactive': 'ปิดใช้งาน',
    'jobTypeMgmt.addDeptModal': 'เพิ่มหน่วยงานใหม่',
    'jobTypeMgmt.editModal': 'แก้ไขข้อมูลประเภทงาน',
    'jobTypeMgmt.deptNameInput': 'ชื่อหน่วยงาน',
    'jobTypeMgmt.deptPlaceholder': 'กรอกชื่อหน่วยงาน เช่น ไฟฟ้า, IT, อาคาร...',
    'jobTypeMgmt.colDelete': 'ลบ',
    'jobTypeMgmt.addNewSub': 'เพิ่มประเภทงานใหม่',
    'jobTypeMgmt.deleteSelectedSub': 'ลบที่เลือก',
    'jobTypeMgmt.uploadIconHint': 'คลิกเพื่ออัปโหลดรุป icon png/jpg',
    'jobTypeMgmt.removeImage': 'ลบรูป',
    'jobTypeMgmt.warnDeptName': 'กรุณากรอกชื่อหน่วยงาน',
    'jobTypeMgmt.addDeptOk': 'เพิ่มหน่วยงานสำเร็จ',
    'jobTypeMgmt.removeIconTitle': 'ยืนยันการลบรูปภาพ?',
    'jobTypeMgmt.removeIconText': 'คุณต้องการลบรูปภาพไอคอนนี้ออกใช่หรือไม่?',
    'jobTypeMgmt.uploadToast': 'อัปโหลดสำเร็จ',
    'jobTypeMgmt.uploadErr': 'อัปโหลดรูปภาพไม่สำเร็จ',
    'jobTypeMgmt.delSubTitle': 'ยืนยันการลบ?',
    'jobTypeMgmt.delSubText': 'คุณต้องการลบประเภทงานนี้ใช่หรือไม่',
    'jobTypeMgmt.permanent': 'ข้อมูลนี้จะถูกลบถาวร',
    'jobTypeMgmt.delBulkSubTitle': 'ยืนยันการลบที่เลือก?',
    'jobTypeMgmt.delBulkSubText': 'คุณต้องการลบประเภทงานจำนวน',
    'jobTypeMgmt.delBulkSubHint': 'รายการใช่หรือไม่? (ลบออกจากตาราง ต้องกดบันทึกเพื่อมีผลจริง)',
    'jobTypeMgmt.delBulkSubLine': 'คุณต้องการลบประเภทงานจำนวน {n} รายการใช่หรือไม่? (ลบออกจากตาราง ต้องกดบันทึกเพื่อมีผลจริง)',
    'jobTypeMgmt.warnComplete': 'กรุณากรอกข้อมูลให้ครบถ้วน',
    'jobTypeMgmt.delDeptTitle': 'ยืนยันการลบหน่วยงาน?',
    'jobTypeMgmt.delDeptText': 'คุณต้องการลบหน่วยงาน',
    'jobTypeMgmt.delDeptLine': 'คุณต้องการลบหน่วยงาน "{name}" ใช่หรือไม่?',
    'jobTypeMgmt.delDeptSure': 'จะถูกลบถาวร',
    'jobTypeMgmt.delDeptBulkTitle': 'ยืนยันการลบหน่วยงาน?',
    'jobTypeMgmt.delDeptBulkText': 'คุณต้องการลบหน่วยงานที่เลือกจำนวน',
    'jobTypeMgmt.deptsWillDelete': 'หน่วยงานที่เลือกทั้งหมดจะถูกลบถาวร',
    'jobTypeMgmt.delDeptOk': 'ลบหน่วยงานสำเร็จ',
    'jobTypeMgmt.deptWillDeleteLine': 'หน่วยงาน "{name}" จะถูกลบถาวร',
    'jobTypeMgmt.addJobType': 'เพิ่มประเภทงาน',
    'jobTypeMgmt.addSubModal': 'เพิ่มประเภทงานใหม่',
    'jobTypeMgmt.editSubModal': 'แก้ไขประเภทงาน',
    'jobTypeMgmt.subNamePh': 'โปรดระบุชื่อประเภทงาน',
    'jobTypeMgmt.slaPh': 'โปรดระบุ SLA',
    'jobTypeMgmt.saveEditBtn': 'บันทึกแก้ไข',
    'jobTypeMgmt.addSubOk': 'เพิ่มประเภทงานเรียบร้อย',
    'jobTypeMgmt.cannotLoadDept': 'ไม่สามารถโหลดข้อมูลหน่วยงานของคุณได้',
    'jobTypeMgmt.delSubNameText': 'คุณต้องการลบประเภทงาน',
    'jobTypeMgmt.subWillDelete': 'จะถูกลบถาวร',
    'jobTypeMgmt.delSubOk': 'ลบประเภทงานเรียบร้อย',
    'jobTypeMgmt.delSubLine': 'คุณต้องการลบประเภทงาน "{name}" ใช่หรือไม่?',
    'jobTypeMgmt.subWillDeleteLine': 'ประเภทงาน "{name}" จะถูกลบถาวร',

    'buildingMgmt.pageTitle': 'จัดการข้อมูล อาคาร',
    'buildingMgmt.addRoom': 'เพิ่มข้อมูลห้อง',
    'buildingMgmt.buildingCol': 'อาคาร',
    'buildingMgmt.roomCol': 'ห้อง',
    'buildingMgmt.editTooltip': 'แก้ไข',
    'buildingMgmt.deleteBuildingTooltip': 'ลบอาคาร',
    'buildingMgmt.editRoomModal': 'แก้ไขชื่อห้อง',
    'buildingMgmt.newRoomName': 'ชื่อห้องใหม่',
    'buildingMgmt.addBuildingModal': 'เพิ่มอาคารใหม่',
    'buildingMgmt.buildingName': 'ชื่ออาคาร',
    'buildingMgmt.buildingPh': 'กรอกชื่ออาคาร....',
    'buildingMgmt.roomName': 'ชื่อห้อง',
    'buildingMgmt.roomPh': 'กรอกชื่อห้อง....',
    'buildingMgmt.editDataModal': 'แก้ไขข้อมูล',
    'buildingMgmt.roomNamesLabel': 'ชื่อห้อง',
    'buildingMgmt.roomInputPh': 'ชื่อห้อง',
    'buildingMgmt.addRoomBtn': 'เพิ่มห้อง',
    'buildingMgmt.addOk': 'เพิ่มข้อมูลเรียบร้อย',
    'buildingMgmt.saveEditBuilding': 'บันทึกการแก้ไข',
    'buildingMgmt.deleteBuildingLine': 'คุณต้องการลบอาคาร "{name}" และห้องทั้งหมดใช่หรือไม่?',
    'buildingMgmt.buildingWillDeleteLine': 'อาคาร "{name}" จะถูกลบถาวร',
    'buildingMgmt.deleteBulkLine': 'คุณต้องการลบอาคารที่เลือกจำนวน {n} รายการ และห้องทั้งหมดใช่หรือไม่?',
    'buildingMgmt.deletingTitle': 'กำลังลบข้อมูล...',
    'buildingMgmt.batchResultTitle': 'ลบสำเร็จ',
    'buildingMgmt.batchResultHtml': 'ลบสำเร็จ {ok} รายการ',
    'buildingMgmt.batchFailLine': 'ล้มเหลว {fail} รายการ',

    'userManual.title': 'คู่มือการใช้งานระบบ (User Manual & Workflow)',
    'userManual.tabUser': '👤 ผู้แจ้งซ่อม (User)',
    'userManual.tabSupervisor': '👨‍💼 หัวหน้างาน (Supervisor)',
    'userManual.tabTech': '🛠️ ช่างซ่อม (Technician)',
    'userManual.tabAdmin': '⚙️ ผู้ดูแลระบบ (Admin)',
    'userManual.userHeading': '▶ ขั้นตอนการทำงานสำหรับ ผู้แจ้งซ่อม (User)',
    'userManual.u1t': '1. แจ้งซ่อม',
    'userManual.u1d': 'ระบุรายละเอียดปัญหา สถานที่ และรูปแบบงาน',
    'userManual.u2t': '2. รอการตรวจสอบ',
    'userManual.u2d': 'ติดตามสถานะจากหน้าตาราง (สถานะ: รอรับเรื่อง)',
    'userManual.u3t': '3. ช่างดำเนินการซ่อม',
    'userManual.u3d': 'ช่างผู้รับผิดชอบเข้าดำเนินการซ่อมแซมหน้างาน',
    'userManual.u4t': '4. ยืนยันและประเมิน',
    'userManual.u4d': 'เมื่อซ่อมเสร็จ ระบบจะส่งอีเมลและแจ้งเตือนให้ทำประเมินความพึงพอใจ',
    'userManual.supHeading': '▶ ขั้นตอนการทำงานสำหรับ หัวหน้างาน (Supervisor)',
    'userManual.s1t': '1. รับเรื่องแจ้งซ่อม',
    'userManual.s1d': 'งานแจ้งซ่อมที่ตรงกับหมวดหมู่ของแผนกจะถูกส่งมาให้ดูแล',
    'userManual.s2t': '2. มอบหมายช่าง',
    'userManual.s2d': 'เลือกช่างในสังกัดที่มีความพร้อมเพื่อรับผิดชอบงานนี้',
    'userManual.s3t': '3. ติดตามสถานะ',
    'userManual.s3d': 'ตรวจสอบความคืบหน้าของงาน หรือเปลี่ยนช่างได้หากจำเป็น',
    'userManual.s4t': '4. สรุปผลงาน',
    'userManual.s4d': 'เมื่อช่างซ่อมเสร็จ สามารถตรวจสอบคุณภาพจากประวัติงานได้ครบถ้วน',
    'userManual.techHeading': '▶ ขั้นตอนการทำงานสำหรับ ช่างซ่อม (Technician)',
    'userManual.t1t': '1. รับมอบหมายงาน',
    'userManual.t1d': 'งานที่ได้รับมอบหมายจาก Supervisor จะปรากฏในรายการของช่าง',
    'userManual.t2t': '2. กดรับงาน',
    'userManual.t2d': "กดยืนยันเพื่อเปลี่ยนสถานะเป็น 'กำลังดำเนินการซ่อม'",
    'userManual.t3t': '3. ปฏิบัติงานแก้ไข',
    'userManual.t3d': 'ดำเนินการแก้ไขและซ่อมแซมหน้างานจริงตามใบแจ้งซ่อม',
    'userManual.t4t': '4. บันทึกผลสำเร็จ',
    'userManual.t4d': 'เขียนอธิบายผลการซ่อมและแนบภาพหลังการซ่อมเสร็จ เพื่อปิดงาน',
    'userManual.adminHeading': '▶ ขั้นตอนการทำงานสำหรับ ผู้ดูแลระบบ (Admin)',
    'userManual.a1t': '1. ดูภาพรวมระบบ',
    'userManual.a1d': 'ผ่าน Dashboard ตรวจสอบสถิติและสถานะการซ่อมทั้งหมด',
    'userManual.a2t': '2. จัดการหมวดหมู่ "อื่นๆ"',
    'userManual.a2d': 'ชี้เป้าหมวดหมู่แจ้งซ่อมที่ User ระบุไม่ชัดเจน ส่งให้แผนกที่ถูกต้องดูแล',
    'userManual.a3t': '3. จัดการบุคลากร',
    'userManual.a3d': 'เพิ่ม/ลบ ปรับโอนย้ายแผนก และเลื่อนตำแหน่งพนักงาน',
    'userManual.a4t': '4. คุมโครงสร้างข้อมูล',
    'userManual.a4d': 'ดูแลและอัปเดตข้อมูลประเภทงาน, อาคารสถานที่, และแผนกต่างๆ',
  },
  en: {
    'brand.university': 'Mae Fah Luang University',
    'brand.maintenanceShort': 'Maintenance System',

    'common.other': 'Other',
    'common.logout': 'Log out',
    'common.langTh': 'TH',
    'common.langEn': 'EN',

    'login.title': 'Online Maintenance Request',
    'login.subtitle': 'Mae Fah Luang University',
    'login.signIn': 'Sign in to the system',
    'login.mfuHint': '* Please use your MFU email to sign in',
    'login.userManual': 'User manual',
    'login.swalGoogleLoadingTitle': 'Loading',
    'login.swalGoogleLoadingText': 'Connecting to Google. Please wait and try again.',
    'login.ok': 'OK',
    'login.verifyingTitle': 'Verifying...',
    'login.verifyingText': 'Please wait while we sign you in',
    'login.successTitle': 'Signed in successfully',
    'login.errorTitle': 'Something went wrong',
    'login.failGeneric': 'Sign-in failed',

    'nav.userManual': 'User manual',
    'nav.logout': 'Log out',
    'nav.dashboard': 'Dashboard',
    'nav.repairs': 'Repairs',
    'nav.staff': 'Staff management',
    'nav.jobTypes': 'Job types',
    'nav.buildings': 'Buildings',

    'mainuser.pageTitle': 'Maintenance request',
    'mainuser.reportBtn': 'New request',
    'mainuser.tabReports': 'My requests',
    'mainuser.tabHistory': 'History',
    'mainuser.ticketCancelledTitle': 'Request cancelled',
    'mainuser.ticketCancelledText': 'This maintenance request has been cancelled.',
    'mainuser.evalBeforeNewTitle': 'Action required',
    'mainuser.evalBeforeNewText': 'Please complete your evaluation for finished work before submitting a new request.',
    'mainuser.thanksEvalTitle': 'Thank you for your feedback 🎉',
    'mainuser.evalTicketNo': 'Ticket no.:',
    'mainuser.evalScore': 'Rating:',
    'mainuser.evalStars': 'stars ⭐',
    'mainuser.evalComment': 'Comment:',
    'mainuser.evalNoComment': 'None',

    'dashboard.kpiTotalRequests': 'Total repair requests',
    'dashboard.kpiInProgress': 'In progress',
    'dashboard.kpiCompleted': 'Closed',
    'dashboard.kpiOverSla': 'Over SLA',
    'dashboard.kpiSatisfaction': 'Average satisfaction',
    'dashboard.kpiAwaitingEval': 'Awaiting evaluation',
    'dashboard.pieByDepartment': 'Requests by department',
    'dashboard.pieByCategory': 'Requests by category',
    'dashboard.barMonthly': 'Monthly request statistics',
    'dashboard.heatmap': 'Heat map',
    'dashboard.ticketDetails': 'Ticket details',
    'dashboard.reportPdf': 'Report',
    'dashboard.noData': 'No data',
    'dashboard.slaTarget': 'Target:',
    'dashboard.rangeCustom': 'Custom',
    'dashboard.rangeToday': 'Today',
    'dashboard.rangeWeek': 'This week',
    'dashboard.rangeMonth': 'This month',
    'dashboard.rangeYear': 'This year',
    'dashboard.rangeAll': 'All',
    'dashboard.periodPrefix': 'Period: ',
    'dashboard.pdfTitle': 'Maintenance summary report',
    'dashboard.pdfPrintedAt': 'Printed:',
    'dashboard.pdfKpiTotal': 'Total jobs',
    'dashboard.pdfKpiCompleted': 'Closed',
    'dashboard.pdfKpiInProgress': 'In progress',
    'dashboard.pdfKpiOverdue': 'Overdue (SLA)',
    'dashboard.pdfKpiAwaiting': 'Awaiting evaluation',
    'dashboard.pdfKpiSatisfaction': 'Average satisfaction',
    'dashboard.pdfWorkListTitle': 'Job details',
    'dashboard.colTicketNo': 'Ticket no.',
    'dashboard.colDateReported': 'Reported date',
    'dashboard.colReporterDept': 'Reporter / dept.',
    'dashboard.colStatus': 'Status',
    'dashboard.colSla': 'SLA',
    'dashboard.colClosedAt': 'Closed at',
    'dashboard.noRowsInPeriod': 'No data in this period',
    'dashboard.summaryTitle': 'Summary by category',
    'dashboard.summaryColDept': 'Department / unit',
    'dashboard.summaryColCategory': 'Category / department',
    'dashboard.summaryColTotal': 'Total jobs',
    'dashboard.summaryColCompleted': 'Closed',
    'dashboard.summaryColInProgress': 'In progress',
    'dashboard.summaryColOverdue': 'Overdue',
    'dashboard.noSummaryRows': 'No summary data',
    'dashboard.pdfModalTitle': 'Select period for PDF download',
    'dashboard.dateFrom': 'From date',
    'dashboard.dateTo': 'To date',
    'dashboard.download': 'Download',
    'dashboard.slaOverdue': 'Overdue',
    'dashboard.slaOnTime': 'On time',
    'dashboard.supervisorPrefix': 'Supervisor: ',
    'dashboard.status.pending': 'Pending',
    'dashboard.status.assigned': 'Assigned',
    'dashboard.status.in_progress': 'In progress',
    'dashboard.status.done': 'Done',
    'dashboard.status.welldone': 'Done (evaluated)',
    'dashboard.status.cancelled': 'Cancelled',
    'dashboard.status.rejected': 'Rejected',
    'dashboard.field.ticketNo': 'Ticket no.',
    'dashboard.field.dateInformed': 'Reported date',
    'dashboard.field.reporter': 'Reporter / department',
    'dashboard.field.category': 'Job type',
    'dashboard.field.status': 'Status',
    'dashboard.field.sla': 'SLA',
    'dashboard.field.assignee': 'Assignee',
    'dashboard.field.closedDate': 'Closed date',
    'dashboard.pdfPeriodTpl': 'Data from {from} to {to}',
    'dashboard.shortMonth1': 'Jan',
    'dashboard.shortMonth2': 'Feb',
    'dashboard.shortMonth3': 'Mar',
    'dashboard.shortMonth4': 'Apr',
    'dashboard.shortMonth5': 'May',
    'dashboard.shortMonth6': 'Jun',
    'dashboard.shortMonth7': 'Jul',
    'dashboard.shortMonth8': 'Aug',
    'dashboard.shortMonth9': 'Sep',
    'dashboard.shortMonth10': 'Oct',
    'dashboard.shortMonth11': 'Nov',
    'dashboard.shortMonth12': 'Dec',

    'ticketDetail.title': 'Maintenance request details',
    'ticketDetail.timeline.waitShort': 'Wait',
    'ticketDetail.timeline.submitted': 'Submitted',
    'ticketDetail.timeline.received': 'Acknowledged',
    'ticketDetail.timeline.inRepair': 'In repair',
    'ticketDetail.timeline.awaitingEval': 'Awaiting evaluation',
    'ticketDetail.timeline.done': 'Completed',
    'ticketDetail.role.user': 'User',
    'ticketDetail.role.supervisor': 'Supervisor',
    'ticketDetail.role.technician': 'Technician',
    'ticketDetail.role.userConfirm': 'User confirm',
    'ticketDetail.rating.n1': 'Needs improvement',
    'ticketDetail.rating.n2': 'Fair',
    'ticketDetail.rating.n3': 'Average',
    'ticketDetail.rating.n4': 'Good',
    'ticketDetail.rating.n5': 'Excellent',
    'ticketDetail.evalPlease': '⭐ Rate your satisfaction',
    'ticketDetail.evalResult': '⭐ Satisfaction result',
    'ticketDetail.evalSubmit': 'Submit rating',
    'ticketDetail.saving': 'Saving...',
    'ticketDetail.cancelWhy': 'Cancellation reason',
    'ticketDetail.noReason': 'No reason given',
    'ticketDetail.assignees': '👤 People responsible',
    'ticketDetail.supervisorAssigner': 'Assigning supervisor:',
    'ticketDetail.when': 'When:',
    'ticketDetail.technician': 'Technician:',
    'ticketDetail.waitTechAccept': '(Waiting for technician to accept)',
    'ticketDetail.finishedWhen': 'Completed on:',
    'ticketDetail.sectionReport': '🛠️ Request information',
    'ticketDetail.ticketNo': 'Ticket no.',
    'ticketDetail.reporter': 'Reporter:',
    'ticketDetail.onBehalf': 'On behalf of:',
    'ticketDetail.phoneMobile': 'Mobile phone:',
    'ticketDetail.phoneWork': 'Work phone:',
    'ticketDetail.jobType': 'Job type:',
    'ticketDetail.workArea': 'Work area:',
    'ticketDetail.timeSlot': 'Preferred time:',
    'ticketDetail.mapPoint': '📍 Report location map:',
    'ticketDetail.openMaps': 'Open in Google Maps',
    'ticketDetail.problem': 'Problem / work:',
    'ticketDetail.photoBefore': 'Photo (before repair):',
    'ticketDetail.workOutcome': '📝 Work summary',
    'ticketDetail.fixDetail': 'Resolution details:',
    'ticketDetail.photoAfter': 'Technician photo (after repair):',
    'ticketDetail.close': 'Close',
    'ticketDetail.outdoor': 'Outdoor',
    'ticketDetail.locationBuilding': 'Building {b} / Room {r}',
    'ticketDetail.mapPinTitle': 'Report pin',
    'ticketDetail.swalEvalOk': 'Rating saved',
    'ticketDetail.swalError': 'Something went wrong',
    'ticketDetail.swalSaveFail': 'Could not save',
    'ticketDetail.techUnknown': 'Name unknown (ID only)',
    'ticketDetail.techPending': '- (Pending)',
    'ticketDetail.cancelTicketBtn': 'Cancel request',
    'ticketDetail.deptCombined': 'Department:',
    'ticketDetail.phonePersonalShort': 'Mobile:',
    'ticketDetail.phoneWorkShort': 'Work phone:',
    'ticketDetail.otherCatBanner': '“Other” category — assign a department',
    'ticketDetail.userSpecifiedJob': 'Type specified by user:',
    'ticketDetail.pickDept': 'Select department:',
    'ticketDetail.placeholderDept': '-- Select department --',
    'ticketDetail.assigningDept': 'Assigning...',
    'ticketDetail.assignDeptBtn': 'Assign department',
    'ticketDetail.assignTechHeading': '⚡ Assign to technician',
    'ticketDetail.changeTechHeading': '⚡ Change technician',
    'ticketDetail.pickTech': 'Select technician:',
    'ticketDetail.placeholderTech': '-- Select technician --',
    'ticketDetail.confirmAssignTech': 'Confirm assignment',
    'ticketDetail.confirmChangeTechBtn': 'Confirm change',
    'ticketDetail.waitUserEval': '🕒 Awaiting user rating',
    'ticketDetail.adminAssignBox': '📋 Assignment by admin',
    'ticketDetail.originalUserType': 'Original type from user:',
    'ticketDetail.adminAssignedDeptLabel': 'Department assigned by admin:',
    'ticketDetail.adminAssignerLabel': 'Assigned by (admin):',
    'ticketDetail.assignDateLabel': 'Assigned on:',
    'ticketDetail.supervisorLabelRole': 'Assigning supervisor:',
    'ticketDetail.technicianLabelRole': 'Technician:',
    'ticketDetail.changeTechShort': 'Change technician',
    'ticketDetail.otherAssignedSuffix': ' (assigned)',
    'ticketDetail.otherWaitSuffix': ' (awaiting assignment)',
    'ticketDetail.noLocationDetail': 'No location detail',
    'ticketDetail.timeSuffix': '',
    'ticketDetail.youMarker': '(you)',
    'ticketDetail.noName': 'Unknown name',
    'ticketDetail.techNotYet': '- (Not assigned)',
    'ticketDetail.confirmAssignDeptTitle': 'Assign to this department?',
    'ticketDetail.confirmAssignDeptHtml': 'Assign this job to<br><strong>{name}</strong><br>?',
    'ticketDetail.assignDeptSuccess': 'Department assigned. An email has been sent to that department’s supervisor.',
    'ticketDetail.assignDeptFail': 'Could not assign department',
    'ticketDetail.fetchCategoriesFail': 'Could not load departments',
    'ticketDetail.connectFail': 'Could not reach the server',
    'ticketDetail.confirmChangeTechTitle': 'Change technician?',
    'ticketDetail.confirmAssignTitle': 'Confirm assignment?',
    'ticketDetail.confirmChangeTechHtml': 'Change technician to<br><strong>{name}</strong><br>?',
    'ticketDetail.confirmAssignTechHtml': 'Assign this job to<br><strong>{name}</strong><br>?',
    'ticketDetail.selectedTechFallback': 'Selected technician',
    'ticketDetail.assignTechOk': 'Assigned. An email has been sent to the technician.',
    'ticketDetail.changeTechOk': 'Technician updated',
    'ticketDetail.assignTechFail': 'Could not assign',
    'ticketDetail.cancelTicketTitle': 'Cancel this request?',
    'ticketDetail.cancelTicketHtml': 'This cannot be undone.<br><br><b style="color:red;">*Please enter a reason</b>',
    'ticketDetail.cancelPlaceholder': 'Reason...',
    'ticketDetail.cancelAria': 'Cancellation reason',
    'ticketDetail.cancelConfirmBtn': 'Confirm cancel',
    'ticketDetail.closeBtn': 'Close',
    'ticketDetail.cancelReasonRequired': 'Please enter a reason.',
    'ticketDetail.cancelOk': 'Request cancelled',
    'ticketDetail.cancelFail': 'Could not cancel',
    'ticketDetail.supervisor.forwardOther': 'Forward to another department',
    'ticketDetail.supervisor.forwardOtherShort': '🔄 Forward to another department',
    'ticketDetail.supervisor.pickTargetDept': 'Target department:',
    'ticketDetail.supervisor.placeholderDept': '-- Select department --',
    'ticketDetail.supervisor.yourDeptTag': '(your department)',
    'ticketDetail.supervisor.processing': 'Processing...',
    'ticketDetail.supervisor.confirmForward': 'Confirm forward',
    'ticketDetail.supervisor.forwardConfirmTitle': 'Forward this job?',
    'ticketDetail.supervisor.forwardConfirmText': 'Send this job to another department?',
    'ticketDetail.supervisor.forwardOk': 'Job forwarded',
    'ticketDetail.supervisor.forwardFail': 'Could not forward',
    'ticketDetail.supervisor.waitEvalLine': '🕒 Awaiting user rating',
    'ticketDetail.tech.pageTitle': 'Job details',
    'ticketDetail.tech.newJobTitle': '🛠️ New job assigned',
    'ticketDetail.tech.newJobHint': 'Review the details below, then accept to start work',
    'ticketDetail.tech.acceptJob': 'Accept job',
    'ticketDetail.tech.closeSection': '🏁 Report completion (close job)',
    'ticketDetail.tech.repairDetailLabel': 'Work performed:',
    'ticketDetail.tech.repairPlaceholder': 'Describe the repair work...',
    'ticketDetail.tech.photoAfterRequired': 'After photo (required):',
    'ticketDetail.tech.choosePhoto': 'Choose image...',
    'ticketDetail.tech.confirmClose': 'Confirm close',
    'ticketDetail.tech.uploading': 'Uploading...',
    'ticketDetail.tech.selfReporterBadge': 'Your own request',
    'ticketDetail.tech.statusLine': 'Status:',
    'ticketDetail.tech.waitReporterEval': '✅ Work finished — awaiting reporter rating',
    'ticketDetail.tech.jobWelldone': '🏆 Job fully closed',
    'ticketDetail.tech.supervisorWhen': 'When:',
    'ticketDetail.tech.youTechnician': 'Technician (you):',
    'ticketDetail.tech.locationDetailLabel': 'Location detail:',
    'ticketDetail.tech.problemLabel': 'Problem details:',
    'ticketDetail.tech.photoAfterOptional': 'Photo (before repair):',
    'ticketDetail.tech.acceptConfirmTitle': 'Accept job?',
    'ticketDetail.tech.acceptConfirmText': 'Accept this job?',
    'ticketDetail.tech.acceptConfirmBtn': 'Accept',
    'ticketDetail.tech.acceptOkTitle': 'Accepted',
    'ticketDetail.tech.acceptOkText': 'You can start work now',
    'ticketDetail.tech.acceptFail': 'Could not accept',
    'ticketDetail.tech.rejectJob': 'Reject job (Return to supervisor)',
    'ticketDetail.tech.rejectConfirmTitle': 'Reject this repair job?',
    'ticketDetail.tech.rejectConfirmText': 'This ticket will be returned to the supervisor for reassignment.',
    'ticketDetail.tech.rejectReasonPlaceholder': 'Please specify the rejection reason (e.g., out of scope, lacking equipment)...',
    'ticketDetail.tech.rejectReasonRequired': 'Rejection reason is required',
    'ticketDetail.tech.rejectConfirmBtn': 'Confirm rejection',
    'ticketDetail.tech.rejectOkTitle': 'Job rejected',
    'ticketDetail.tech.rejectOkText': 'Ticket has been returned to supervisor',
    'ticketDetail.tech.rejectFail': 'Failed to reject job',
    'ticketDetail.tech.rejectedAlertTitle': 'This job was previously rejected by technician',
    'ticketDetail.tech.rejectedByLabel': 'Rejected by:',
    'ticketDetail.tech.rejectedReasonLabel': 'Reason:',
    'ticketDetail.tech.rejectedBadge': '⚠️ Rejected by Tech',
    'ticketDetail.tech.fileTooBig': 'File too large',
    'ticketDetail.tech.needPhotoTitle': 'Photo required',
    'ticketDetail.tech.needPhotoText': 'Upload an after photo before closing',
    'ticketDetail.tech.needDetailTitle': 'Details required',
    'ticketDetail.tech.needDetailText': 'Describe the work before closing',
    'ticketDetail.tech.closeConfirmTitle': 'Close job?',
    'ticketDetail.tech.closeConfirmText': 'Close this repair job?',
    'ticketDetail.tech.closeOkTitle': 'Saved',
    'ticketDetail.tech.closeOkText': 'Job submitted',
    'ticketDetail.tech.closeFail': 'Could not submit',
    'ticketDetail.statusFull.pending': 'Submitted (awaiting team)',
    'ticketDetail.statusFull.assigned': 'Acknowledged (awaiting technician)',
    'ticketDetail.statusFull.in_progress': 'In progress',
    'ticketDetail.statusFull.done': 'Repair done',
    'ticketDetail.statusFull.welldone': 'Closed',

    'table.user.col.ticketNo': 'Ticket no.',
    'table.user.col.reportedAt': 'Reported date/time',
    'table.user.col.detail': 'Details',
    'table.user.col.status': 'Status',
    'table.user.onBehalf': 'On behalf of:',
    'table.user.btn.track': 'Track',
    'table.user.btn.cancelRequest': 'Cancel request',
    'table.user.legend1': 'Submitted',
    'table.user.legend2': 'Acknowledged',
    'table.user.legend3': 'In progress',
    'table.user.legend4': 'Done',
    'table.user.status.pending': 'Submitted',
    'table.user.status.assigned': 'Acknowledged',
    'table.user.status.in_progress': 'In progress',
    'table.user.status.done': 'Done',
    'table.user.status.welldone': 'Done',
    'table.user.status.cancelled': 'Cancelled',
    'table.user.unknownDept': 'Unspecified',
    'table.user.swalCancelTitle': 'Confirm cancellation?',
    'table.user.swalCancelHtml': 'Cancel this maintenance request?<br><br><b style="color:red;">*Please enter a reason</b>',
    'table.user.swalPlaceholder': 'Reason...',
    'table.user.swalReasonRequired': 'Please enter a cancellation reason.',
    'table.user.swalSuccess': 'Cancelled',
    'table.user.swalSuccessText': 'This request has been cancelled.',
    'table.user.swalErrCancel': 'Could not cancel the request',
    'table.user.swalErrNetwork': 'Could not reach the server',
    'table.user.btnConfirmCancel': 'Confirm cancel',
    'table.user.btnBack': 'Back',
    'table.user.timeSuffix': '',
    'table.common.itemsPerPage': 'Items per page:',

    'table.admin.col.ticketNo': 'Ticket no.',
    'table.admin.col.reportedAt': 'Reported date/time',
    'table.admin.col.detail': 'Details',
    'table.admin.col.status': 'Status',
    'table.admin.onBehalf': 'On behalf of:',
    'table.admin.btn.detail': 'View details',
    'table.admin.btn.assignDept': 'Assign department',
    'table.admin.legend1': 'Pending',
    'table.admin.legend2': 'Acknowledged',
    'table.admin.legend3': 'In progress',
    'table.admin.legend4': 'Done',
    'table.admin.legend5': 'Cancelled',
    'table.admin.col.reporterDetail': 'Reporter / details',
    'table.admin.col.actions': 'Actions',
    'table.admin.status.pending': 'Pending',
    'table.admin.status.assigned': 'Acknowledged',
    'table.admin.status.in_progress': 'In progress',
    'table.admin.status.done': 'Done',
    'table.admin.status.welldone': 'Closed',
    'table.admin.status.cancelled': 'Cancelled',
    'table.admin.subAssigned': ' (assigned)',
    'table.admin.subWaitAssign': ' (awaiting assignment)',
    'table.admin.noUserName': 'Unknown name',

    'table.tech.col.date': 'Date',
    'table.tech.col.issueDetail': 'Job details / reporter',
    'table.tech.reportedDateLabel': 'Report date',
    'table.tech.byPrefix': 'By:',
    'table.tech.supervisorFallback': 'Supervisor',
    'table.tech.reportedBy': 'Reported by:',
    'table.tech.badgeReporter': 'My report',
    'table.tech.badgeAssignee': 'Assigned',
    'table.tech.legend1': 'Submitted',
    'table.tech.legend2': 'Acknowledged',
    'table.tech.legend3': 'In progress',
    'table.tech.legend4': 'Done',
    'table.tech.status.pending': 'Submitted (awaiting team)',
    'table.tech.status.assigned': 'New job',
    'table.tech.status.in_progress': 'In progress',
    'table.tech.status.done': 'Work completed',
    'table.tech.status.welldone': 'Closed',
    'table.tech.status.cancelled': 'Cancelled',
    'table.tech.action.acceptJob': 'Accept job',
    'table.tech.action.finishJob': 'Complete job',
    'table.tech.action.detail': 'View details',
    'table.tech.noUserName': 'Unknown name',

    'table.supervisor.col.reporterDetail': 'Reporter / details',
    'table.supervisor.badgeReporter': 'My report',
    'table.supervisor.badgeDept': 'Department',
    'table.supervisor.noCategory': 'No category',
    'table.supervisor.noUserName': 'Unknown name',
    'table.supervisor.action.assign': 'Assign job',
    'table.supervisor.action.track': 'Track',

    'reportList.pageTitle': 'Repairs',
    'reportList.newRequest': 'New request',
    'reportList.tabActive': 'Active requests',
    'reportList.tabHistory': 'History',

    'sendReport.modalTitle': 'Maintenance request',
    'sendReport.sectionRepair': 'Repair details',
    'sendReport.sectionRepairHint': 'Describe the issue and location',
    'sendReport.jobType': 'Job type',
    'sendReport.noJobTypes': 'No job types found',
    'sendReport.otherTypeLabel': 'Specify other job type',
    'sendReport.otherTypePlaceholder': 'Describe the job type...',
    'sendReport.problemLabel': 'Problem / work required',
    'sendReport.problemPlaceholder': 'Describe the problem or repair needed...',
    'sendReport.imageLabel': 'Attach photo',
    'sendReport.pickOrCapture': 'Choose file or take a photo',
    'sendReport.remove': 'Remove',
    'sendReport.takePhoto': 'Take photo',
    'sendReport.choosePhoto': 'Choose photo',
    'sendReport.imageHint': 'Images only (.jpg, .png)',
    'sendReport.workArea': 'Work area',
    'sendReport.insideBuilding': 'Inside building',
    'sendReport.insideBuildingSub': 'Building',
    'sendReport.outsideBuilding': 'Outside building',
    'sendReport.outsideBuildingSub': 'Outdoor',
    'sendReport.buildingRoom': 'Building – room',
    'sendReport.buildingPlaceholder': 'e.g. C3-201 or A1-1-201',
    'sendReport.buildingFormatHint': '* Use format: building-room (e.g. C3-201)',
    'sendReport.buildingFound': 'Building matched:',
    'sendReport.pinLocation': 'Pin location on map',
    'sendReport.reporterSection': 'Reporter',
    'sendReport.reporterHint': 'Contact details',
    'sendReport.reporterName': 'Reporter name',
    'sendReport.onBehalfLabel': 'On behalf of (name of person requesting repair)',
    'sendReport.onBehalfPlaceholder': 'Name if reporting for someone else',
    'sendReport.personalPhone': 'Mobile phone',
    'sendReport.workPhone': 'Work phone',
    'sendReport.phonePlaceholderMobile': 'e.g. 0900000000',
    'sendReport.phonePlaceholderWork': 'e.g. 021234567',
    'sendReport.availability': 'Preferred date and time',
    'sendReport.dateLabel': 'Date:',
    'sendReport.startLabel': 'Start:',
    'sendReport.endLabel': 'End:',
    'sendReport.availabilityHint': 'Choose when you are available for the repair',
    'sendReport.cancel': 'Cancel',
    'sendReport.confirm': 'Confirm',
    'sendReport.submitting': 'Sending...',
    'sendReport.defaultFirstName': 'User',
    'sendReport.defaultLastName': '',
    'sendReport.timeSuffix': ' at ',
    'sendReport.errEndAfterStart': 'End time must be after start time (same day).',
    'sendReport.errImageOnly': 'Please select an image file only',
    'sendReport.errImageSize': 'Image too large',
    'sendReport.errImageProcess': 'Could not process the image',
    'sendReport.errPhoneRequired': 'Please enter your mobile phone number',
    'sendReport.errPhoneDigits': 'Enter 9–10 digits (numbers only)',
    'sendReport.errPickDate': 'Please choose a preferred date',
    'sendReport.errPickTime': 'Please choose a time range',
    'sendReport.errPickJobType': 'Please select a job type',
    'sendReport.errSpecifyOther': 'Please specify the job type',
    'sendReport.errWorkArea': 'Please select a work area',
    'sendReport.errBuildingFormat': 'Use building-room format (e.g. C3-201)',
    'sendReport.errMapPin': 'Please drop a pin on the map',
    'sendReport.errProblem': 'Please describe the problem',
    'sendReport.errAttachImage': 'Please attach a photo',
    'sendReport.swalIncompleteTitle': 'Incomplete information',
    'sendReport.swalIncompleteText': 'Please fill in all required fields before submitting',
    'sendReport.otherPrefix': 'Other',
    'sendReport.confirmLocation': 'Location:',
    'sendReport.outdoorLocated': 'Outdoor (location pinned)',
    'sendReport.confirmJobType': 'Job type:',
    'sendReport.confirmProblem': 'Problem:',
    'sendReport.confirmOnBehalf': 'On behalf of:',
    'sendReport.confirmPersonalPhone': 'Mobile:',
    'sendReport.confirmWorkPhone': 'Work phone:',
    'sendReport.confirmAvailability': 'Availability:',
    'sendReport.swalConfirmTitle': 'Confirm maintenance request',
    'sendReport.swalEdit': 'Edit',
    'sendReport.swalSuccessTitle': 'Request submitted',
    'sendReport.swalErrorTitle': 'Something went wrong',
    'sendReport.swalErrorText': 'Could not submit the request. Please try again.',

    'mgmt.cancel': 'Cancel',
    'mgmt.save': 'Save',
    'mgmt.add': 'Add',
    'mgmt.edit': 'Edit',
    'mgmt.delete': 'Delete',
    'mgmt.actions': 'Actions',
    'mgmt.confirm': 'Confirm',
    'mgmt.confirmDelete': 'Confirm delete',
    'mgmt.processing': 'Processing...',
    'mgmt.loadingDelete': 'Deleting...',
    'mgmt.loadingRead': 'Reading file...',
    'mgmt.loadingSave': 'Saving...',
    'mgmt.loadingDept': 'Loading department...',
    'mgmt.errFillAll': 'Please fill in all required fields',
    'mgmt.errFillAllShort': 'Please complete all fields',
    'mgmt.success': 'Success',
    'mgmt.warn': 'Notice',
    'mgmt.error': 'Error',
    'mgmt.editSaved': 'Changes saved',
    'mgmt.saveSaved': 'Saved successfully',
    'mgmt.addSaved': 'Added successfully',
    'mgmt.deleteUserTitle': 'Remove this user?',
    'mgmt.deleteUserBulkTitle': 'Remove selected users?',
    'mgmt.sureDelete': 'Are you sure?',
    'mgmt.demoteUserSuffix': 'will be changed to a regular user',
    'mgmt.demoteUsersBulk': 'All selected users will be changed to regular users',
    'mgmt.demoteSuccess': 'User role updated to regular user',
    'mgmt.countItems': 'Count',
    'mgmt.itemsUnit': 'items',
    'mgmt.batchDeleted': 'Removed',
    'mgmt.batchFailed': 'Failed',
    'mgmt.batchAdded': 'Added',
    'mgmt.doneTitle': 'Done',
    'mgmt.donePartial': 'Done (some rows failed)',
    'mgmt.noData': 'No data',
    'mgmt.noDataToSave': 'Nothing to save',
    'mgmt.fileReadError': 'Could not read the file or invalid format',
    'mgmt.rowIncompleteSuffix': 'incomplete data',
    'mgmt.errOperation': 'Operation failed',
    'mgmt.deleteBuildingTitle': 'Confirm delete?',
    'mgmt.deleteBuildingBulkTitle': 'Delete selected buildings?',
    'mgmt.deleteBuildingSure': 'Are you sure?',
    'mgmt.deleteBuildingText': 'Delete building',
    'mgmt.deleteBuildingAndRooms': 'and all its rooms?',
    'mgmt.buildingWillDelete': 'will be permanently deleted',
    'mgmt.buildingsSelectedWillDelete': 'All selected buildings will be permanently deleted',
    'mgmt.deleteBuildingBulkText': 'Delete the selected',
    'mgmt.deleteOk': 'Deleted',
    'mgmt.deleteBuildingDone': 'Building removed',
    'mgmt.cannotDelete': 'Could not delete',
    'mgmt.editRoomSaved': 'Room name updated',
    'mgmt.editFail': 'Update failed',
    'mgmt.addFail': 'Could not add',
    'mgmt.loadFail': 'Could not load data',
    'mgmt.saveFail': 'Save failed',
    'mgmt.deleteFail': 'Delete failed',

    'staffMgmt.pageTitle': 'Staff management',
    'staffMgmt.addStaff': 'Add staff',
    'staffMgmt.deleteSelected': 'Delete selected',
    'staffMgmt.addModal': 'Add staff',
    'staffMgmt.editModal': 'Edit staff',
    'staffMgmt.previewModal': 'Preview from file',
    'staffMgmt.firstName': 'First name',
    'staffMgmt.lastName': 'Last name',
    'staffMgmt.email': 'Email',
    'staffMgmt.phone': 'Phone',
    'staffMgmt.userType': 'Role',
    'staffMgmt.department': 'Department',
    'staffMgmt.allDepts': 'All departments',
    'staffMgmt.selectDept': 'Select department',
    'staffMgmt.addViaXlsx': 'Import .xlsx',
    'staffMgmt.templateFile': 'Template file',
    'staffMgmt.confirmBulk': 'Confirm import',
    'staffMgmt.deptLabel': 'Department:',
    'staffMgmt.yourDept': 'Your department',

    'jobTypeMgmt.pageTitle': 'Job types',
    'jobTypeMgmt.addDept': 'Add department',
    'jobTypeMgmt.deptNameCol': 'Department',
    'jobTypeMgmt.jobTypesCol': 'Job types',
    'jobTypeMgmt.icon': 'Icon',
    'jobTypeMgmt.jobTypeName': 'Job type name',
    'jobTypeMgmt.slaHours': 'SLA (hours)',
    'jobTypeMgmt.slaShort': 'SLA (h)',
    'jobTypeMgmt.status': 'Status',
    'jobTypeMgmt.active': 'Active',
    'jobTypeMgmt.inactive': 'Inactive',
    'jobTypeMgmt.addDeptModal': 'Add department',
    'jobTypeMgmt.editModal': 'Edit job types',
    'jobTypeMgmt.deptNameInput': 'Department name',
    'jobTypeMgmt.deptPlaceholder': 'e.g. Electrical, IT, Building...',
    'jobTypeMgmt.colDelete': 'Del',
    'jobTypeMgmt.addNewSub': 'Add job type',
    'jobTypeMgmt.deleteSelectedSub': 'Delete selected',
    'jobTypeMgmt.uploadIconHint': 'Click to upload icon (png/jpg)',
    'jobTypeMgmt.removeImage': 'Remove image',
    'jobTypeMgmt.warnDeptName': 'Please enter a department name',
    'jobTypeMgmt.addDeptOk': 'Department added',
    'jobTypeMgmt.removeIconTitle': 'Remove image?',
    'jobTypeMgmt.removeIconText': 'Remove this icon image?',
    'jobTypeMgmt.uploadToast': 'Uploaded',
    'jobTypeMgmt.uploadErr': 'Upload failed',
    'jobTypeMgmt.delSubTitle': 'Confirm delete?',
    'jobTypeMgmt.delSubText': 'Delete this job type?',
    'jobTypeMgmt.permanent': 'This cannot be undone',
    'jobTypeMgmt.delBulkSubTitle': 'Delete selected?',
    'jobTypeMgmt.delBulkSubText': 'Delete',
    'jobTypeMgmt.delBulkSubHint': 'row(s)? (Remove from table; click Save to apply.)',
    'jobTypeMgmt.delBulkSubLine': 'Delete {n} selected job type(s)? (Removed from the table; click Save to apply.)',
    'jobTypeMgmt.warnComplete': 'Please complete all fields',
    'jobTypeMgmt.delDeptTitle': 'Delete department?',
    'jobTypeMgmt.delDeptText': 'Delete department',
    'jobTypeMgmt.delDeptLine': 'Delete department "{name}"?',
    'jobTypeMgmt.delDeptSure': 'This will be permanent',
    'jobTypeMgmt.delDeptBulkTitle': 'Delete departments?',
    'jobTypeMgmt.delDeptBulkText': 'Delete the selected',
    'jobTypeMgmt.deptsWillDelete': 'All selected departments will be permanently deleted',
    'jobTypeMgmt.delDeptOk': 'Department deleted',
    'jobTypeMgmt.deptWillDeleteLine': 'Department "{name}" will be permanently deleted',
    'jobTypeMgmt.addJobType': 'Add job type',
    'jobTypeMgmt.addSubModal': 'Add job type',
    'jobTypeMgmt.editSubModal': 'Edit job type',
    'jobTypeMgmt.subNamePh': 'Job type name',
    'jobTypeMgmt.slaPh': 'SLA hours',
    'jobTypeMgmt.saveEditBtn': 'Save changes',
    'jobTypeMgmt.addSubOk': 'Job type added',
    'jobTypeMgmt.cannotLoadDept': 'Could not load your department',
    'jobTypeMgmt.delSubNameText': 'Delete job type',
    'jobTypeMgmt.subWillDelete': 'This will be permanent',
    'jobTypeMgmt.delSubOk': 'Job type deleted',
    'jobTypeMgmt.delSubLine': 'Delete job type "{name}"?',
    'jobTypeMgmt.subWillDeleteLine': 'Job type "{name}" will be permanently deleted',

    'buildingMgmt.pageTitle': 'Buildings',
    'buildingMgmt.addRoom': 'Add room',
    'buildingMgmt.buildingCol': 'Building',
    'buildingMgmt.roomCol': 'Rooms',
    'buildingMgmt.editTooltip': 'Edit',
    'buildingMgmt.deleteBuildingTooltip': 'Delete building',
    'buildingMgmt.editRoomModal': 'Edit room name',
    'buildingMgmt.newRoomName': 'New room name',
    'buildingMgmt.addBuildingModal': 'Add building',
    'buildingMgmt.buildingName': 'Building name',
    'buildingMgmt.buildingPh': 'Enter building name...',
    'buildingMgmt.roomName': 'Room name',
    'buildingMgmt.roomPh': 'Enter room name...',
    'buildingMgmt.editDataModal': 'Edit',
    'buildingMgmt.roomNamesLabel': 'Rooms',
    'buildingMgmt.roomInputPh': 'Room name',
    'buildingMgmt.addRoomBtn': 'Add room',
    'buildingMgmt.addOk': 'Added successfully',
    'buildingMgmt.saveEditBuilding': 'Save changes',
    'buildingMgmt.deleteBuildingLine': 'Delete building "{name}" and all its rooms?',
    'buildingMgmt.buildingWillDeleteLine': 'Building "{name}" will be permanently deleted',
    'buildingMgmt.deleteBulkLine': 'Delete {n} selected building(s) and all their rooms?',
    'buildingMgmt.deletingTitle': 'Deleting...',
    'buildingMgmt.batchResultTitle': 'Deleted',
    'buildingMgmt.batchResultHtml': 'Deleted {ok} item(s)',
    'buildingMgmt.batchFailLine': 'Failed: {fail} item(s)',

    'userManual.title': 'User manual & workflow',
    'userManual.tabUser': '👤 Requester (User)',
    'userManual.tabSupervisor': '👨‍💼 Supervisor',
    'userManual.tabTech': '🛠️ Technician',
    'userManual.tabAdmin': '⚙️ Admin',
    'userManual.userHeading': '▶ Workflow for requesters (User)',
    'userManual.u1t': '1. Submit request',
    'userManual.u1d': 'Describe the issue, location, and work type',
    'userManual.u2t': '2. Awaiting triage',
    'userManual.u2d': 'Track status in the list (e.g. Pending)',
    'userManual.u3t': '3. Technician works',
    'userManual.u3d': 'Assigned technician performs the repair on site',
    'userManual.u4t': '4. Confirm & rate',
    'userManual.u4d': 'When work is done, you will be notified to confirm and rate satisfaction',
    'userManual.supHeading': '▶ Workflow for supervisors',
    'userManual.s1t': '1. Receive requests',
    'userManual.s1d': 'Requests matching your department category appear in your queue',
    'userManual.s2t': '2. Assign technician',
    'userManual.s2d': 'Choose an available technician in your team',
    'userManual.s3t': '3. Track progress',
    'userManual.s3d': 'Monitor the job or reassign if needed',
    'userManual.s4t': '4. Review outcome',
    'userManual.s4d': 'When the technician finishes, review history for quality',
    'userManual.techHeading': '▶ Workflow for technicians',
    'userManual.t1t': '1. Receive assignment',
    'userManual.t1d': 'Jobs assigned by a supervisor appear in your list',
    'userManual.t2t': '2. Accept job',
    'userManual.t2d': "Confirm to set status to 'In progress'",
    'userManual.t3t': '3. Perform repair',
    'userManual.t3d': 'Complete the work on site per the ticket',
    'userManual.t4t': '4. Record completion',
    'userManual.t4d': 'Describe results and attach photos to close the job',
    'userManual.adminHeading': '▶ Workflow for administrators',
    'userManual.a1t': '1. System overview',
    'userManual.a1d': 'Use the dashboard for stats and repair status',
    'userManual.a2t': '2. Handle “Other” category',
    'userManual.a2d': 'Route unclear requests to the correct department',
    'userManual.a3t': '3. Manage people',
    'userManual.a3d': 'Add/remove users and adjust departments or roles',
    'userManual.a4t': '4. Master data',
    'userManual.a4d': 'Maintain job types, buildings, and departments',
  },
}
